export const getPendingWaitInfo = (ticket, now = Date.now()) => {
  if (!ticket || ticket.status !== "pending") return null;

  const createdAt = ticket.createdAt
    ? new Date(ticket.createdAt).getTime()
    : NaN;

  if (!Number.isFinite(createdAt)) {
    return { level: "unknown", minutes: null, createdAt: null };
  }

  const minutes = Math.max(
    0,
    Math.floor((now - createdAt) / 60000)
  );

  return {
    level: minutes >= 10 ? "red" : minutes >= 5 ? "yellow" : "green",
    minutes,
    createdAt
  };
};

export const formatPendingWait = minutes => {
  if (minutes === null || minutes === undefined) {
    return "No disponible";
  }

  const days = Math.floor(minutes / 1440);
  const hours = Math.floor((minutes % 1440) / 60);
  const mins = minutes % 60;

  if (days > 0) return `${days} d ${hours} h`;
  if (hours > 0) return `${hours} h ${mins} min`;

  return `${mins} min`;
};
